import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from '../../../utils/createSignedRequest';

export const postCreateCustomer = async (businessId, customerCreationData, activeEmployerInfo) => {
  const apiPath = `customer/${businessId}/create-customer`;

  const { activeEmployerId, activeEmployerBusinessId } = activeEmployerInfo;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
      ...(activeEmployerId && { 'X-Active-Employer-Id': activeEmployerId }),
      ...(activeEmployerBusinessId && {
        'X-Active-Employer-Business-Id': activeEmployerBusinessId,
      }),
    },
    body: JSON.stringify(customerCreationData), // aws4 looks for body; axios for data
    data: customerCreationData,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
